module.exports = __webpack_public_path__ + "media/CN_003.cdee1ec1.mp3";